import { createSlice } from '@reduxjs/toolkit'

import { initialState } from 'store/pages/typeticket/state'

import { getBulkData } from '../actions/getBulkData'
import { getData } from '../actions/getData'

export const TypeTicketSlice = createSlice({
  name: 'typeticket',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      const typeticket = action.payload
      state.typetickets[typeticket.id] = typeticket
    })
    builder.addCase(getBulkData.fulfilled, (state, action) => {
      action.payload.forEach((typeticket) => (state.typetickets[typeticket.id] = typeticket))
    })
  },
})
